
<script>
import {Vue, Watch, Prop} from 'vue-property-decorator';
import TimePicker from './time-picker';
import dayjs from 'dayjs';
import {formatTimeNumber, isAvailable} from './util';
import {Options} from 'vue-class-component';
import {ElPopover, ElButton} from 'element-plus';
import ZTIcon from '../../components/zt-icon';

@Options({
    emits: ['update:value', 'change']
})
export default class TimePickerRanger extends Vue {

    @Prop({type: Boolean, default: false}) disabled;
    @Prop({type: Boolean, default: false}) allowClear;
    @Prop({type: String, default: '开始时间'}) startPlaceholder;
    @Prop({type: String, default: '结束时间'}) endPlaceholder;

    @Prop({type: Array, default: function() {
        return [];
    }}) value;

    currentValue = [];
    popoverVisible = false;

    created() {
        this.resetCurrentValue();
    }

    // @Watch('popoverVisible')
    // popoverVisibleChange(newVal) {
    //     if (newVal) {
    //         this.$nextTick(() => {
    //             setTimeout(() => {
    //                 this.$refs.startTimePicker.srcollValueIntoCenter(false);
    //                 this.$refs.endTimePicker.srcollValueIntoCenter(false);
    //             }, 200);
    //         })
    //     }
    // }

    scrollValueIntoView() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.$refs.startTimePicker.srcollValueIntoCenter(true);
                this.$refs.endTimePicker.srcollValueIntoCenter(true);
            }, 300);
        });
    }

    resetCurrentValue() {
        const [start, end] = this.value;
        const currentStart = this.getDateFromString(start);
        const currentEnd = this.getDateFromString(end);
        this.currentValue = [currentStart, currentEnd];
    }

    onOk() {
        if (this.diffValue()) {
            const changeValue = this.getChangeValue();
            this.$emit('change', changeValue);
            this.$emit('update:value', changeValue);
        }
        this.popoverVisible = false;
    }

    onCancel() {
        this.resetCurrentValue();
        this.popoverVisible = false;
    }

    @Watch('value')
    valueChange() {
        this.resetCurrentValue();
    }

    getChangeValue() {
        const [currentStartHour, currentStartMinute, currentEndHour, currentEndMinute] = this.getCurrentValueFormatString();
        const start = currentStartHour && currentStartMinute && `${currentStartHour}:${currentStartMinute}` || '';
        const end = currentEndHour && currentEndMinute && `${currentEndHour}:${currentEndMinute}` || '';
        return [start, end];
    }

    getCurrentValueFormatString() {
        const [currentStart, currentEnd] = this.currentValue;
        const currentStartHour = isAvailable(currentStart) ? formatTimeNumber(currentStart.getHours()) : '';
        const currentStartMinute = isAvailable(currentStart) ? formatTimeNumber(currentStart.getMinutes()) : '';
        const currentEndHour = isAvailable(currentEnd) ? formatTimeNumber(currentEnd.getHours()) : '';
        const currentEndMinute = isAvailable(currentEnd) ? formatTimeNumber(currentEnd.getMinutes()) : '';
        return [currentStartHour, currentStartMinute, currentEndHour, currentEndMinute];
    }

    diffValue() {
        const [start, end] = (this.value || []);
        const [currentStartHour, currentStartMinute, currentEndHour, currentEndMinute] = this.getCurrentValueFormatString();
        const [startHour, startMinute]  = (start || '').split(':');
        const [endHour, endMinute]  = (end || '').split(':');
        return currentStartHour !== startHour ||
            currentStartMinute !== startMinute ||
            currentEndHour !== endHour ||
            currentEndMinute !== endMinute;
    }

    getDateFromString(str) {
        if (str) {
            const [hour, minute] = str.split(':');
            const d = new Date();
            d.setHours(hour);
            d.setMinutes(minute);
            return d;
        }
    }

    startTimePickerChange(v) {
        const { currentValue } = this;
        const [ start, end ] = currentValue;
        if (end) {
            end.setSeconds(0);
            end.setMilliseconds(0);
            v.setMilliseconds(0);
            v.setSeconds(0);
            if (v.valueOf() >= end.valueOf()) {
                const startTimePickerComp = this.$refs['startTimePicker'];
                const minutes = startTimePickerComp.getMinutes();
                const hours = startTimePickerComp.getHours();
                const minute = end.getMinutes();
                const hour = end.getHours();
                const minuteIndex = minutes.findIndex(item => item == minute);
                if (minutes[minuteIndex - 1]) {
                    v.setMinutes(minutes[minuteIndex - 1]);
                } else {
                    const hourIndex = hours.findIndex(item => item == hour);
                    if (hours[hourIndex - 1]) {
                        v.setHours(hours[hourIndex - 1]);
                        v.setMinutes(minutes[minutes.length - 1]);
                    }
                }
            }
        }

        
        this.currentValue = [v, end];
    }

    endTimePickerChange(v) {
        const { currentValue } = this;
        const [ start ] = currentValue;
        if (start) {
            start.setSeconds(0);
            v.setSeconds(0);
            start.setMilliseconds(0);
            v.setMilliseconds(0);
            if (v.valueOf() <= start.valueOf()) {
                const endTimePickerComp = this.$refs['endTimePicker'];
                const minutes = endTimePickerComp.getMinutes();
                const hours = endTimePickerComp.getHours();
                const minute = start.getMinutes();
                const hour = start.getHours();
                const minuteIndex = minutes.findIndex(item => item == minute);
                if (minutes[minuteIndex + 1]) {
                    v.setMinutes(minutes[minuteIndex + 1]);
                } else {
                    const hourIndex = hours.findIndex(item => item == hour);
                    if (hours[hourIndex + 1]) {
                        v.setHours(hours[hourIndex + 1]);
                        v.setMinutes(minutes[0]);
                    }
                }
            }
        }
        this.currentValue = [start, v];
    }

    getPopperContent() {
        const { currentValue } = this;
        const [ start, end ] = currentValue;
        return <div>
            <div class="time-ranger-picker">
                <TimePicker
                    ref="startTimePicker"
                    onChange={this.startTimePickerChange.bind(this)}
                    value={start}
                    maxTime={end}
                    class="time-ranger-picker-start"
                    title="开始时间"
                />
                <TimePicker
                    ref="endTimePicker"
                    disabled={!start}
                    allowAddEndMinute={true}
                    onChange={this.endTimePickerChange.bind(this)}
                    value={end}
                    minTime={start}
                    title="结束时间"
                />
            </div>
            <div class="item-ranger-picker-btns">
                <ElButton type="primary" onClick={this.onOk.bind(this)}>确定</ElButton>
                <ElButton onClick={this.onCancel.bind(this)}>取消</ElButton>
            </div>
        </div>
    }

    dataFormat(date, placeholder) {
        return date && dayjs(date).format('HH:mm') || <span class="ranger-time-placeholder">
            {placeholder}
        </span> || '';
    }

    clearValue() {
        this.currentValue = [];
    }

    render() {
        const { currentValue, disabled, startPlaceholder, endPlaceholder, allowClear } = this;
        const [start, end] = currentValue;
        const notAllowClear = !start && !end || !allowClear;
        return <div class="zt-time-picker-ranger-wrapper">
            <ElPopover
                onShow={this.scrollValueIntoView.bind(this)}
                transition="el-zoom-in-top"
                disabled={disabled}
                show-arrow={false}
                popper-class="zt-time-picker-ranger-popper"
                placement="bottom-start"
                width={201}
                onHide={() => this.popoverVisible = false}
                visible={this.popoverVisible}
            >
                {{
                    default: () => this.getPopperContent(),
                    reference: () => {
                        return <div class={['zt-time-picker-ranger', {'disabled': disabled}]} onClick={() => this.popoverVisible = true}>
                            <div class="zt-time-picker-ranger-icon">
                                <ZTIcon type="time" />
                            </div>
                            <div class="zt-time-picker-ranger-input">
                                {this.dataFormat(start, startPlaceholder)}
                            </div>
                            <span class="zt-time-picker-ranger-separator">至</span>
                            <div class="zt-time-picker-ranger-input">
                                {this.dataFormat(end, endPlaceholder)}
                            </div>

                            <div class={['zt-time-picker-ranger-tool', {
                                'not-allow-clear': notAllowClear
                            }]}>
                                <span onClick={notAllowClear ? () => {} : this.clearValue.bind(this)} class="tool-clear"><zt-icon type="close"/></span>
                            </div>
                        </div>;
                    }
                }}
            </ElPopover>
        </div>
    }
}
</script>

<style lang="scss">
@import './var.scss';

.zt-time-picker-ranger-wrapper {
    display: inline-block;
}
.zt-time-picker-ranger-popper {
    padding: 0!important;
    .time-ranger-picker {
        width: 200px;
        display: flex;
        border-bottom: 1px solid $border-base-color;
        &-start {
            border-right: 1px solid $border-base-color;
        }
    }

    .item-ranger-picker-btns {
        padding: 10px;
    }
}


.zt-time-picker-ranger {
    width: 215px;
    border: 1px solid $border-base-color;
    border-radius: $border-base-radius;
    background: #fff;
    vertical-align: middle;
    display: inline-block;
    transition: all 0.5s;
    cursor: pointer;
    position: relative;
    // padding-right: 20px;
    // padding-left: $time-picker-line-height;
    &, & * {
        box-sizing: border-box;
    }
    &-icon {
        text-align: right;
        display: inline-block;
        margin-right: 4px;
        width: $time-picker-line-height - 8px;
        font-size: 14px;
        color: $disabled-color;
    }

    // &:hover {
    //     border-color: $--input-border-color-hover;
    // }
    &-separator {
        display: inline-block;
        line-height: $time-picker-line-height;
        color: #999;
        font-size: 14px;
        width: $separator-width;
        text-align: center;
    }
    &-input {
        display: inline-block;
        // padding: 0 10px 0 0;
        box-sizing: border-box;
        font-size: 14px;
        border: none;
        line-height: $time-picker-line-height;
        // width: 60px;
        text-align: center;
        width: calc((100% - #{$separator-width} - #{$time-picker-line-height} - 20px) / 2);
    }
    &-tool {
        position: absolute;
        display: inline-block;
        right: 0;
        top: 0;
        line-height: $time-picker-line-height;
        width: $time-picker-line-height;
        text-align: center;

        &.not-allow-clear {
            opacity: 0;
        }

        .tool-clear {
            line-height: $time-picker-line-height;
            width: $time-picker-line-height;
            height: $time-picker-line-height;
            position: absolute;
            text-align: center;
            left: 0;
            top: 0;
            opacity: 0;
            z-index: 1;
            font-size: 14px;
            // transition: all 0.5s;
        }
        
    }

    &:not(.disabled):hover {
        .zt-time-picker-ranger-tool {
            .tool-clear {
                opacity: 1;
            }
            .tool-icon  {
                display: none;
            }
        }
    }
    .ranger-time-placeholder {
        color: $placeholder-color;
    }

    &.disabled {
        border-color: $disabled-color;
        &, & .ranger-time-placeholder, & .zt-time-picker-ranger-separator {
            color: $disabled-color;
        }
    }
}

</style>
